import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import type { MuiTelInputCountry } from 'mui-tel-input';

import typography from '@/theme/typography';
import countries from '@/utils/countries';

import AdminInviteForm from './AdminInviteForm';

const OrgAdminTab: React.FC = () => {
  const { t } = useTranslation('organizations');
  const { watch } = useFormContext();
  const formCountries = watch('countries');

  const defaultCountry = useMemo(() => {
    const firstCountry = Array.isArray(formCountries) ? formCountries[0] : formCountries;
    if (!firstCountry) return undefined;

    // Convert alpha-3 country code to alpha-2 for phone input
    return countries.alpha3ToAlpha2(firstCountry) as MuiTelInputCountry | undefined;
  }, [formCountries]);

  return (
    <Stack
      sx={{
        p: 4,
        pt: 2,
        '& .MuiFormControl-root': {
          p: 0
        }
      }}
      gap={2}
    >
      <Typography variant="body2" fontWeight={typography.fontWeightMedium} color="text.secondary">
        {t('layouts.organizations.create.fields.organizationAdmin')}
      </Typography>
      <AdminInviteForm namePrefix="admin" defaultCountry={defaultCountry} />
    </Stack>
  );
};

export default OrgAdminTab;
